@import '@hevoio/hevo-ui-toolkit/styles/variables';

.shimmerContainer {
  height: 90px;
}

.statusBadge {
  padding-top: $spacer * .125;
  padding-bottom: $spacer * .125;
}
